export enum MAPinAnnotationColor {
  /**
   * 红色大头针
   */
  ColorRed = 0,
  /**
   * 绿色大头针
   */
  ColorGreen = 1,
  /**
   * 紫色大头针
   */
  ColorPurple = 2,
}
